import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const CancelPage = () => {
    const history = useHistory();

    useEffect(() => {
        // Redirect to the home page after the pop-up closes
        if (window.opener) {
            window.opener.location.href = "/";
            window.close();
        } else {
            history.push("/"); // Fallback for when not in a pop-up
        }
    }, [history]);

    return (
        <div>
            <h1>Something went wrong!</h1>
            <p>Please try again</p>
        </div>
    );
};

export default CancelPage;
